import { getUserInfo } from "redux/slice/faxSlice";
import { setIsErrorPage, setUserInfo, setLoading, showInvalidUserModal } from "redux/slice/commanSlice";
import { AppDispatch } from "redux/store";
import { User } from "@auth0/auth0-react";

// Helper to reset user info and loading state
const resetUserState = (dispatch: AppDispatch) => {
  dispatch(setUserInfo(false));
  dispatch(setLoading(false));
};

/**
 * Shared async function to get user info and handle invalid user logic.
 * @param dispatch - Redux dispatch function
 * @param user - User object (should have .email)
 * @param navigation - Navigation function (e.g., from react-router)
 */

export const onGetUserInfo = async (
  dispatch: AppDispatch,
  user: User | undefined,
  navigation: (path: string) => void
): Promise<boolean> => {
  try {
    const username = user?.email;
    if (username !== undefined) {
      const res: any = await dispatch(getUserInfo(username)).unwrap();
      if (res.error === "email account") {
        dispatch(
          showInvalidUserModal({
            error: "Account Not Found",
            message: res?.message || "Invalid User",
          })
        );
        resetUserState(dispatch);
        return false;
      }
      resetUserState(dispatch);
      return true;
    } else {
      resetUserState(dispatch);
      return false;
    }
  } catch (error: any) {
    dispatch(setIsErrorPage(true));
    navigation("/invalid-user");
    dispatch(setLoading(false));
    console.log("Get USer Info Err: --->", error?.message);
    return false;
  }
};